module.exports = __webpack_public_path__ + "img/hero-2x.0e5806a.png";